// TODO - Leverage io-core package functionality instead of duplicated code.
interface MultipleOfferStorage {
    lastOfferVin: string;
    offers: { [vin: string]: Offer };
}

export interface Offer {
    expirationDateUtc: Date;
    expirationDisplayDate?: string;
    offerAmount: number;
    offerCode: string;
    offerType: 'eligible' | 'ineligible' | 'pending';
    vehicleInformation: { profile: { make: string; model: string; year: number } };
}

const multipleInstantOfferLocalStorageName = 'suycMultipleIcoOffer';

export const getOffer = (): Offer | null => {
    if (typeof window == 'undefined' || !window || !window.localStorage) {
        console.warn('No window.localStorage, check environment for rendering');
        return null;
    }
    let offer: Offer | null = null;
    const offerString = window.localStorage.getItem(multipleInstantOfferLocalStorageName);
    if (offerString) {
        const offers = JSON.parse(offerString) as MultipleOfferStorage;
        if (offers.lastOfferVin && offers.offers) {
            offer = offers.offers[offers.lastOfferVin];
        }
    }

    return offer;
};
